module.exports = __webpack_public_path__ + "img/pic-person.84b609d7.jpg";